import { render, staticRenderFns } from "./jak-zbudowac-portfel-akcji-od-zera.md?vue&type=template&id=26945f8a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports